import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { DoTestMatchingFeatureNameQuestionInstance } from '../../../student-do-test/model/Question/do-test-matching-feature-name-question.store';
import { TestSectionStoreInstance } from '../../../student-do-test/model/test-section.store';
import { CircleTextType, ViewTestMatching } from './ViewTestMatching';

export interface MatchingFeatureNameAnswerProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestMatchingFeatureNameQuestionInstance;
  currentSection?: TestSectionStoreInstance;
}

export const ViewTestMatchingFeatureName = observer((props: MatchingFeatureNameAnswerProps) => {
  const { data, ...rest } = props;
  const { no, options, featureNames } = data;

  return (
    <ViewTestMatching
      currentQuestionNo={no}
      title="List of Findings"
      findingOptions={options}
      questionOptions={featureNames}
      findingOptionCircleTextType={CircleTextType.ALPHABET}
      questionOptionCircleTextType={CircleTextType.NUMBER}
      {...rest}
    />
  );
});
